var watchlistPositionAdd = {
	title: "Stelle hinzufügen",
	subtitle: "Beobachtungsliste: {value}",
	noSelectedPositions: "Derzeit sind keine Stellen zum Hinzufügen zur Beobachtungsliste ausgewählt.",
	singleSelectedPosition: "Es ist 1 Position ausgewählt, die zur Beobachtungsliste hinzugefügt werden sollen.",
	multipleSelectedPositions: "Es sind {value} Positionen ausgewählt, die der Beobachtungsliste hinzugefügt werden sollen.",
	submit: "Ok",
	cancel: "Abbrechen",
	remove: "Entfernen",
	validationErrors: {
		positionExists: "Ihre Auswahl befindet sich bereits auf Ihrer Beobachtungsliste"
	},
	noWatchlists: {
		title: "Info",
		message: "Es wurde noch keine Beobachtungsliste erstellt."
	}
};
var de = {
	watchlistPositionAdd: watchlistPositionAdd
};

export { de as default, watchlistPositionAdd };
